var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmiratesFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 496,
    viewBox: "0 0 496 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 304V369.6C0 396.8 21.6 416 48 416H448C474.4 416 496 396.8 496 369.6V304H0Z",
    fill: "#232222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448 80H48C21.6 80 0 99.2 0 126.4V192H496V126.4C496 99.2 474.4 80 448 80Z",
    fill: "#49A948"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 192H0V304H496V192Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 368.8C496 397.6 474.4 416 448 416H48C21.6 416 0 395.2 0 368",
    fill: "#232222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80H48C21.6 80 0 99.2 0 126.4V190.4V191.2V305.6V306.4V370.4C0 396.8 21.6 416 48 416H120V80Z",
    fill: "#E73B36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120 192H0V191.2V304.8V304H120V192Z",
    fill: "#DB2C2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 304V306.4V370.4C0 396.8 21.6 416 48 416H120V304H0Z",
    fill: "#CC2525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368C0 400 21.6 416 48 416H120V368H0Z",
    fill: "#B70808"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80H48L120 100V80Z",
    fill: "#B70808"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmiratesFlag);
export default __webpack_public_path__ + "static/media/emirates-flag.6fbf8f4b7d4028825f26ba6547692a12.svg";
export { ForwardRef as ReactComponent };